(function () {
  var el = document.querySelector('[data-company-id]');
  var COMPANY_ID = el.getAttribute('data-company-id');
  var LIST_ID = el.getAttribute('data-list-id');
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // ── Inject z-index fix for intl-tel-input dropdown ──
  var style = document.createElement('style');
  style.textContent = '.iti--container { z-index: 2147483647 !important; }';
  document.head.appendChild(style);

  function init() {
    var form = document.querySelector('.ve_form');
    var block = document.querySelector('.ve_form_block');
    if (!form || !block) return;

    // ── Modal scroll lock ──
    var modalOverlay = document.querySelector('[modal-wrapper]');
    if (modalOverlay) {
      var observer = new MutationObserver(function () {
        var isHidden = modalOverlay.classList.contains('hide');
        if (isHidden) {
          document.body.style.overflow = '';
          document.documentElement.style.overflow = '';
          document.body.style.position = '';
          document.body.style.top = '';
          window.scrollTo(0, parseInt(document.body.dataset.scrollY || '0'));
        } else {
          document.body.dataset.scrollY = window.scrollY;
          document.body.style.position = 'fixed';
          document.body.style.top = '-' + window.scrollY + 'px';
          document.body.style.overflow = 'hidden';
          document.body.style.width = '100%';
        }
      });
      observer.observe(modalOverlay, { attributes: true, attributeFilter: ['class'] });
    }

    var kw = document.querySelector('.klaviyo-form-RQMvFp');
    if (kw) kw.style.display = 'none';

    var submitBtn = form.querySelector('input[type="submit"][formbutton="submit"]');
    var invalidBtn = form.querySelector('[formbutton="invalid"]');
    var successMsg = block.querySelector('.success-message-2');
    var errorMsg = block.querySelector('.error-message');
    var required = [].slice.call(form.querySelectorAll('input[required]'));

    // ── intl-tel-input setup ──
    var phoneInput = form.querySelector('input[name="ve-phone"]');
    var iti = null;
    if (phoneInput) {
      iti = window.intlTelInput(phoneInput, {
        initialCountry: 'us',
        preferredCountries: ['us', 'ca', 'gb'],
        separateDialCode: true,
        strictMode: true,
        dropdownContainer: document.body,
        loadUtils: function () {
          return import('https://cdn.jsdelivr.net/npm/intl-tel-input@26.3.2/build/js/utils.js');
        }
      });
    }

    // ── Element references ──
    var consentCheckbox = form.querySelector('input[name="Consent-Checkbox"]');

    // ── Validation ──
    function isValid() {
      return required.every(function (input) {
        if (input.type === 'checkbox') return input.checked;
        if (input.type === 'email') return EMAIL_RE.test(input.value.trim());
        if (input.name === 've-phone') return true;
        return input.value.trim() !== '';
      });
    }

    function isPhoneValid() {
      if (!iti) return true;
      var number = iti.getNumber();
      if (!number) return true;
      return iti.isValidNumber();
    }

    function isConsentValid() {
      if (!phoneInput || !consentCheckbox) return true;
      var rawValue = phoneInput.value.replace(/\D/g, '');
      if (rawValue.length > 0 && !consentCheckbox.checked) return false;
      return true;
    }



    // ── Phone error display ──
    var phoneError = document.createElement('span');
    phoneError.style.cssText = 'color:red;font-size:12px;display:none;margin-top:4px;';
    if (phoneInput) phoneInput.parentNode.appendChild(phoneError);

    function showPhoneError(msg) {
      phoneError.textContent = msg;
      phoneError.style.display = 'block';
    }

    function clearPhoneError() {
      phoneError.style.display = 'none';
    }

    if (phoneInput) {
      phoneInput.addEventListener('input', clearPhoneError);
      phoneInput.addEventListener('countrychange', clearPhoneError);
    }

    // ── Consent error display ──
    var consentError = document.createElement('span');
    consentError.style.cssText = 'color:red;font-size:12px;display:none;margin-top:4px;';
    if (consentCheckbox) consentCheckbox.closest('label').after(consentError);

    function showConsentError(msg) {
      consentError.textContent = msg;
      consentError.style.display = 'block';
    }

    function clearConsentError() {
      consentError.style.display = 'none';
    }

    if (consentCheckbox) {
      consentCheckbox.addEventListener('change', clearConsentError);
    }
    if (phoneInput) {
      phoneInput.addEventListener('input', clearConsentError);
    }

    // ── Prevent Shopify native form submission ──
    form.setAttribute('action', 'javascript:void(0)');
    form.setAttribute('method', 'post');

    // ── Submit ──
    var submitting = false;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (submitting || !isValid()) return;

      if (!isPhoneValid()) {
        var errorMap = [
          'Invalid number',
          'Invalid country code',
          'Number is too short',
          'Number is too long',
          'Invalid number'
        ];
        var errorCode = iti.getValidationError();
        showPhoneError(errorMap[errorCode] || 'Invalid phone number');
        return;
      }

      if (!isConsentValid()) {
        showConsentError('SMS consent is required when providing a phone number');
        return;
      }

      submitting = true;
      if (submitBtn) submitBtn.disabled = true;
      clearPhoneError();
      clearConsentError();

      var val = function (sel) { var el = form.querySelector(sel); return el ? el.value.trim() : ''; };
      var phone = iti ? iti.getNumber() : '';

      var profileAttrs = {
        email: val('input[name="contact[email]"]'),
        phone_number: phone,
        first_name: val('input[name="contact[first_name]"]'),
        last_name: val('input[name="contact[last_name]"]'),
        subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
      };

      if (consentCheckbox && consentCheckbox.checked && phone) {
        profileAttrs.subscriptions.sms = { marketing: { consent: 'SUBSCRIBED' } };
      }

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + COMPANY_ID, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2025-01-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Website Sign-up Form',
              profile: { data: { type: 'profile', attributes: profileAttrs } }
            },
            relationships: { list: { data: { type: 'list', id: LIST_ID } } }
          }
        })
      })
        .then(function (r) {
          if (r.ok || r.status === 202) {
            var lf = block.querySelector('form');
            if (lf) {
              lf.style.display = 'none';
              lf.onsubmit = function () { return false; };
            }
            if (successMsg) successMsg.style.display = 'block';
            if (errorMsg) errorMsg.style.display = 'none';
          } else { throw new Error(r.status); }
        })
        .catch(function () {
          if (errorMsg) errorMsg.style.display = 'block';
          if (successMsg) successMsg.style.display = 'none';
          submitting = false;
          if (submitBtn) submitBtn.disabled = false;
        });
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();